import { useDispatch } from "react-redux";
import { fetchFavProducts, removeFavourite, setFavourite } from "../../store/reducers/favourites/apiThunk";
import { useState } from "react";

export function useFavourite() {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()

    const getFavProducts = async () => {
        try {
            await dispatch(fetchFavProducts())
            setLoading(false);
        } catch (error) {
            console.error("Error fetching favourite products:", error);
            setLoading(false);
        }
      }

      const setFavouriteProduct = async (id) => {
        setLoading(true);
          const dataToSend = {
            product: id
          }

        try {
            await dispatch(setFavourite(dataToSend))
            getFavProducts()
        } catch (error) {
            console.error("Error setting favourite product:", error);
            setLoading(false);
        }
      }

      const removeFavProduct = async (id) => {
        setLoading(true);
        try {
            await dispatch(removeFavourite(`?id=${id}`))
            getFavProducts()
        } catch (error) {
            console.error("Error removing favourite product:", error);
            setLoading(false);
        }
      }

  return {
    getFavProducts,
    setFavouriteProduct,
    removeFavProduct,
    loading
  };
}
